// extracted by mini-css-extract-plugin
module.exports = {"UnknownHeavyShippingCharge":"unknownHeavyShippingCharge_UnknownHeavyShippingCharge__Vme_2","message":"unknownHeavyShippingCharge_message__Iu2fy"};